export default ({ savedItems: { showWarningBanner } }) => showWarningBanner;
